import { CarQuote } from './car-quote.model';
import { CarRiskData } from './car-risk-data';
import { HomeRiskData } from './home-risk-data';
import { IntegralRiskData } from './integral-risk-data.model';
import { PersonalsAccidentsRiskData } from './personals-accidents-risk-data';

export class CarQuoteCard extends CarQuote {
  plan: string;
  title: string;
  description: string;
  subtitle: string;
  note?: string;
  franchises?: Array<Partial<CarQuoteCard>>;
  paymentFee?: number;
  monthlyCost: number;
  riskData?: CarRiskData | PersonalsAccidentsRiskData | HomeRiskData | IntegralRiskData;
  isSelected?: boolean;
}
